module.exports = __webpack_public_path__ + "img/guide_1_1.900fe62a.svg";